export const UNTRADEABLE_ONLY = "untradeable_only";
export const PLAYERS_FROM = "players_from";
export const INCLUDE_DUPLICATES = "include_duplicates";
export const EXCLUDE_GOLD_PLAYERS = "exclude_golds";
export const EXCLUDE_SILVER_PLAYERS = "exclude_silvers";
export const EXCLUDE_BRONZE_PLAYERS = "exclude_bronzes";
export const EXCLUDE_ACTIVE_SQUAD = "exclude_active_squad";
export const INCLUDED_PLAYERS = "included_players";
export const EXCLUDED_PLAYERS = "excluded_players";

export const ELITE_SUBSCRIPTION = "elite";
export const PRO_SUBSCRIPTION = "pro";
export const ULTIMATE_SUBSCRIPTION = "ultimate";

export const ELITE_YEARLY_SUBSCRIPTION = "elite_yearly";
export const PRO_YEARLY_SUBSCRIPTION = "pro_yearly";
export const ULTIMATE_YEARLY_SUBSCRIPTION = "ultimate_yearly";

// Experiment IDs

// export const EXPERIMENT_ID_MY_CLUB_IS_FREE = "CRO-MY-CLUB-20250328-01"; // GROUP A OR B
// export const EXPERIMENT_ID_MY_CLUB_IS_ELITE = "CRO-MY-CLUB-20250328-02"; // GROUP A OR B

export const EXCLUDE_PAID_EVOLUTIONS = "exclude_paid_evolutions";
export const EXCLUDE_COMPLETED_EVOLUTIONS = "exclude_completed_evolutions";

export const EXPERIMENT_EVENTS = {
  CLICK_MY_PLAYERS: "navigateMyPlayers",
  CLICK_MY_EVOLUTIONS: "navigateMyEvolutions",
  CLICK_GO_TO_SUBSCRIPTION: "landingPageCtaClicked",
  CLICK_GO_TO_CHECKOUT: "goToCheckout",
  USER_IS_IN_EXPERIMENT: "userLanded",
};

export const IOS_CLUB_IMPORT_APP_URL =
  "https://apps.apple.com/us/app/club-import/id6737269250";

export const BREAKPOINTS = {
  MEDIUM_MOBILE: {
    value: 375,
    query: "(max-width: 375px)",
  },
  MOBILE: {
    value: 768,
    query: "(max-width: 768px)",
  },
  TOUCH_DEVICE: {
    value: 1024,
    query: "(max-width: 1024px)",
  },
  SMALL_DESKTOP: {
    value: 1280,
    query: "(max-width: 1279px)",
  },
  MAX_CONTENT: {
    value: 1536,
    query: "(max-width: 1536px)",
  },
};
